import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { ThemeContext } from "../Theme";

import styles from "./Heading.scss";

export const HeadingDefaultTagName = "p";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const Heading = forwardRef(
  (
    {
      children,
      isResponsive,
      tag: CustomTag,
      variants,
      customClass,
      ...others
    },
    ref
  ) => {
    const context = React.useContext(ThemeContext);

    const classNames = [
      ...new Set(
        cx(
          variants || styles.heading,
          context && styles[context],
          customClass,
          {
            [styles.responsive]: isResponsive,
          }
        ).split(" ")
      ),
    ].join(" ");
    return (
      <CustomTag className={classNames} ref={ref} {...others}>
        {children}
      </CustomTag>
    );
  }
);

Heading.propTypes = {
  tag: PropTypes.string,
  variants: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  customClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isResponsive: PropTypes.bool,
};

Heading.defaultProps = {
  tag: HeadingDefaultTagName,
  variants: "",
  customClass: undefined,
  isResponsive: true,
};

Heading.Variant = {
  hero: styles.hero,
  primary: styles.primary,
  secondary: styles.secondary,
  tertiary: styles.tertiary,
  quaternary: styles.quaternary,
  copy: styles.copy,
  heroS: styles.heroS,
  primaryS: styles.primaryS,
  secondaryS: styles.secondaryS,
  tertiaryS: styles.tertiaryS,
  quaternaryS: styles.quaternaryS,
  copyS: styles.copyS,
  heroM: styles.heroM,
  primaryM: styles.primaryM,
  secondaryM: styles.secondaryM,
  tertiaryM: styles.tertiaryM,
  quaternaryM: styles.quaternaryM,
  copyM: styles.copyM,
  heroL: styles.heroL,
  primaryL: styles.primaryL,
  secondaryL: styles.secondaryL,
  tertiaryL: styles.tertiaryL,
  quaternaryL: styles.quaternaryL,
  copyL: styles.copyL,
  heroXl: styles.heroXl,
  primaryXl: styles.primaryXl,
  secondaryXl: styles.secondaryXl,
  tertiaryXl: styles.tertiaryXl,
  quaternaryXl: styles.quaternaryXl,
  copyXl: styles.copyXl,
  uppercase: styles.uppercase,
  marginBottomNone: styles.marginBottomNone,
  padded: styles.padded,
  paddedBig: styles.paddedBig,
  paddedBottom: styles.paddedBottom,
  paddedBottomBig: styles.paddedBottomBig,
  paddedTop: styles.paddedTop,
  paddedTopBig: styles.paddedTopBig,
  display: styles.display,
  displayS: styles.displayS,
  displayM: styles.displayM,
  displayL: styles.displayL,
  displayXl: styles.displayXl,
  highlight: styles.highlight,
  hightlightS: styles.highlightS,
  highlightM: styles.highlightM,
  highlightL: styles.highlightL,
  highlightXl: styles.highlightXl,
  brand: styles.brand,
};

Heading.displayName = "Heading";

export default Heading;
